import { get2dEmptyPosition } from "../common";

import type { ConditionType, Position2D } from "@/models/common";
import type {
  DataOrchestrationNodeType,
  OutcomeOption,
} from "@/models/orchestration";

export const CONDITION_NUMBER_COMPARISON_TYPES: ConditionType[] = [
  "less_than",
  "less_than_or_equal",
  "greater_than",
  "greater_than_or_equal",
  "equal",
  "not_equal",
] as const;

export const VALID_OPPOSITE_TYPES: ConditionType[] = [
  "boolean",
  ...CONDITION_NUMBER_COMPARISON_TYPES,
];

export const OPPOSITE_CONDITIONS: Partial<
  Record<ConditionType, ConditionType>
> = {
  less_than: "greater_than_or_equal",
  less_than_or_equal: "greater_than",
  greater_than: "less_than_or_equal",
  greater_than_or_equal: "less_than",
  equal: "not_equal",
  not_equal: "equal",
};

export const NODE_TYPE_TRANSITION = "stage_transitions" as const;
export const NODE_TYPE_DO_TEMPLATE = "orchestrations" as const;

export const INITIAL_STEP_DROPZONE_ID = "initial_step_dropzone" as const;

export const outcomeOptions: OutcomeOption[] = [
  {
    id: "pass",
    title: "Pass",
  },
  {
    id: "fail",
    title: "Fail",
  },
  {
    id: "manual review",
    title: "Manual Review",
  },
];

export const nodesGraphPositionAdjustments: Record<
  DataOrchestrationNodeType,
  Position2D
> = {
  step: get2dEmptyPosition(),
  outcome: { x: 104, y: 49 },
  ["step-dropzone"]: { x: -99, y: 85 },
  ["outcome-dropzone"]: { x: 44, y: 180 },
};

export const nodesStructuredPositionAdjustments: Record<
  DataOrchestrationNodeType,
  Position2D
> = {
  step: get2dEmptyPosition(),
  outcome: { x: 104, y: 49 },
  ["step-dropzone"]: { x: 5, y: 10 },
  ["outcome-dropzone"]: { x: 44, y: 50 },
};

export const STEP_NODE_WIDTH = 368;
export const STEP_NODE_HEIGHT = 125;
export const STEP_NODE_HEIGHT_WITH_LABEL = STEP_NODE_HEIGHT + 35;

export const OUTCOME_NODE_HEIGHT = 36;
